/* eslint-disable import/prefer-default-export */
import { axiosServicesV3 } from 'utils/services';

export const decryptId = async (encryptedId: string, type: string) => {
    // Guard against empty/undefined input
    if(!encryptedId) return '';

    const response = await axiosServicesV3.post('encrypted-id/', { encryptedId: encryptedId, type: type });
    return response.data;
};
